import { Row, Col, Typography, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const { Text } = Typography;

const declatations = [
	'The transporter is not liable for any loss or damage to the consignment unless caused by proven negligence or willful misconduct.',
	'The sender must accurately declare the contents in compliance with all laws; the transporter is not liable for undeclared or misdeclared items.',
	'The transporter is not responsible for receiver refusal unless due to proven negligence or non-compliance with agreed terms.',
	'The transporter is not liable for failures due to circumstances beyond its control.',
	'Liability for loss or damage is limited to the declared value unless otherwise specified.',
];

export function LRDeclaration() {
	return (
		<Row gutter={0}>
			<Col>
				<Text>Disclaimer:</Text>
				{declatations.map((declaration) => (
					<Space direction="horizontal" key={declaration}>
						<CheckOutlined height={3} width={2} />
						<Text>{declaration}</Text>
					</Space>
				))}
			</Col>
		</Row>
	);
}
